<template>
<dashboard-layout>
    <slot></slot> <!-- سيتم عرض محتويات Dashboard.vue هنا -->
</dashboard-layout>
</template>

<script>
import DashboardLayout from "./dashboard-layout.vue";

export default {
    name: "dashboard",
    components: {
        DashboardLayout
    },
    inject: ['auth'],
    data() {
        return {
            // currentLocale: '',
            main: [],
        }
    },
    async created() {
        await this.getMain();
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        async getMain() {
            await axios.get('main').then(response => {
                // toast.success("content loading...", {
                //     timeout: 2000
                // });
                this.main = response.data?.data;
                // this.currentLocale = response.data?.data?.lang;
                // this.$i18n.locale = this.currentLocale;
                // console.log(this.currentLocale);

            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
    },
}
</script>
